import { useTarget } from 'providers/target/useTarget';
import React, { useRef } from 'react';
import { IContentsModule } from 'types';

interface Props {
  module: IContentsModule;
}

function EditText({ module }: Props) {
  const el = useRef<HTMLDivElement>(null);

  const { targetList, setTargetList } = useTarget();

  const handleInput = (e: React.FormEvent<HTMLDivElement>) => {
    const newValue = e.currentTarget.innerHTML || '';

    setTargetList(
      targetList.map((t) => {
        if (t.id === module.id) {
          return {
            ...module,
            data: newValue,
          };
        }

        return t;
      }),
    );
  };

  return (
    <div
      ref={el}
      css={{ outline: 'none', background: '#fff' }}
      contentEditable
      onBlur={handleInput}
      dangerouslySetInnerHTML={{ __html: module.data }}
    />
  );
}

export { EditText };
